/* OREN — flow: hover prefetch fallback for browsers without the Speculation Rules API */
(function(){
  if(HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) return;
  var done = {};
  function ok(a){
    if(!a || !a.href) return false;
    if(a.origin !== location.origin) return false;
    if(a.pathname === location.pathname) return false;
    if(a.search) return false;
    var p = a.pathname;
    if(p.indexOf('/cart') === 0 || p.indexOf('/checkout') === 0 || p.indexOf('/account') === 0) return false;
    return true;
  }
  document.addEventListener('mouseover', function(e){
    var a = e.target.closest && e.target.closest('a');
    if(!ok(a) || done[a.href]) return;
    done[a.href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = a.href;
    l.as = 'document';
    document.head.appendChild(l);
  }, { passive: true });
})();

/* OREN — intro hand-off: fire the content reveal the moment the overlay starts fading,
   so sections don't pop in a beat after the intro. */
(function(){
  var html = document.documentElement;
  function fire(){ if(document.body){ document.body.classList.add('intro-done'); } }
  if(html.classList.contains('intro-revealing')){ fire(); return; }
  try{
    var mo = new MutationObserver(function(){
      if(html.classList.contains('intro-revealing')){ fire(); mo.disconnect(); }
    });
    mo.observe(html, { attributes:true, attributeFilter:['class'] });
  }catch(e){}
})();

/* OREN — scroll position guard: the homepage was re-opening mid-page (on the Johann
   section) because the browser restored a previous scroll position from a working
   session. On the homepage we disable that restore and pin to the top on load.
   Inner pages keep normal back-button restore; real #anchor links are untouched. */
(function(){
  var isHome = document.body && document.body.classList.contains('template-index');
  try{
    if('scrollRestoration' in history){
      history.scrollRestoration = isHome ? 'manual' : 'auto';
    }
  }catch(e){}
  function toTop(){
    if(location.hash) return;
    if(!document.body || !document.body.classList.contains('template-index')) return;
    window.scrollTo(0, 0);
  }
  window.addEventListener('pageshow', toTop);
})();
